import { api } from "@/lib/api";
import type {
  TournamentDto,
  LeagueDto,
  PublicLeagueDto,
  CreateLeagueRequest,
  JoinCodeRequest,
} from "@/types/api";

export const contextApi = {
  tournaments: () => api.get<TournamentDto[]>("/api/tournaments"),
  leagues: () => api.get<LeagueDto[]>("/api/leagues"),
  publicLeagues: () => api.get<PublicLeagueDto[]>("/api/leagues/public"),
  createLeague: (body: CreateLeagueRequest) => api.post<LeagueDto>("/api/leagues", body),
  joinPublic: (id: string) => api.post<void>(`/api/leagues/${id}/join`),
  joinByCode: (body: JoinCodeRequest) => api.post<void>("/api/leagues/join-code", body),
};
